//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets clients.
 */
export function get(protocol: Types.TransportProtocol, config?: AxiosRequestConfig | undefined): Promise<Types.TransportClientDto[]> {
    let url_ = getBaseUrl() + "/api/transport-clients/{protocol}";
    if (protocol === undefined || protocol === null)
      throw new Error("The parameter 'protocol' must be defined.");
    url_ = url_.replace("{protocol}", encodeURIComponent("" + protocol));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGet?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGet(_response);
    });
}

function processGet(response: AxiosResponse): Promise<Types.TransportClientDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initTransportClientDto(item)
              );
            }
        return Promise.resolve<Types.TransportClientDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.TransportClientDto[]>(null as any);
}

/**
 * Updates the time when transporter was active
 */
export function update(protocol: Types.TransportProtocol, direction: Types.TransportMessageDirection, dto: Types.TransportClientDto, config?: AxiosRequestConfig | undefined): Promise<Types.TransportClientDto> {
    let url_ = getBaseUrl() + "/api/transport-clients/{protocol}/{direction}";
    if (protocol === undefined || protocol === null)
      throw new Error("The parameter 'protocol' must be defined.");
    url_ = url_.replace("{protocol}", encodeURIComponent("" + protocol));
    if (direction === undefined || direction === null)
      throw new Error("The parameter 'direction' must be defined.");
    url_ = url_.replace("{direction}", encodeURIComponent("" + direction));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeTransportClientDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdate,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigUpdate?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdate(_response);
    });
}

function processUpdate(response: AxiosResponse): Promise<Types.TransportClientDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initTransportClientDto(resultData200);
        return Promise.resolve<Types.TransportClientDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.TransportClientDto>(null as any);
}
let _requestConfigGet: Partial<AxiosRequestConfig> | null;
export function getGetRequestConfig() {
  return _requestConfigGet;
}
export function setGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGet = value;
}
export function patchGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGet = patch(_requestConfigGet ?? {});
}

let _requestConfigUpdate: Partial<AxiosRequestConfig> | null;
export function getUpdateRequestConfig() {
  return _requestConfigUpdate;
}
export function setUpdateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdate = value;
}
export function patchUpdateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdate = patch(_requestConfigUpdate ?? {});
}